<div class="flex flex-col">
  <app-section-header [title]="'Manager Profiles'"> </app-section-header>
  <div class="flex justify-end item-center content-stretch">
    <mat-form-field appearance="outline" class="w-1/4 content-list_search-box">
      <input
        matInput
        [formControl]="managerSearchFormControl"
        placeholder="Search..."
        [name]="'search'"
        [matAutocomplete]="autoCompleteId"
      />
      <mat-icon matSuffix class="items-center ml-2">search</mat-icon>
      <mat-autocomplete
        [panelWidth]="'fit'"
        #autoCompleteId="matAutocomplete"
        (optionSelected)="onSelectManager($event)"
      >
        <ng-container
          *ngIf="
            managerSearchResults &&
              managerSearchResults.length &&
              !isSearchingManager;
            else noData
          "
        >
          <mat-option
            *ngFor="let search of managerSearchResults"
            [value]="search"
            class="text-sm"
          >
            {{ search.displayName }}
          </mat-option>
        </ng-container>
        <ng-template #noData>
          <mat-option
            *ngIf="!!managerSearchFormControl.value && !isSearching"
            disabled
          >
            No results
          </mat-option>
        </ng-template>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="w-full min-w-full font-sans mat-elevation-z0 content__table">
    <div
      class="relative w-full min-w-full font-sans mat-elevation-z0 content__table"
    >
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="w-full min-w-full font-sans table-fixed content__table"
        matSortActive="modifiedDate"
        matSortDirection="desc"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <mat-label>Name</mat-label>
          </th>
          <td mat-cell *matCellDef="let manager" class="py-3">
            <a
              [routerLink]="['/managers', manager.id]"
              class="text-blue-500 hover:underline"
            >
              {{ manager.name }}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="languages">
          <th mat-header-cell *matHeaderCellDef>
            <mat-label>Languages</mat-label>
          </th>
          <td mat-cell *matCellDef="let manager" class="py-3">
            {{ getLanguages(manager.bio) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lastUpdatedOn">
          <th mat-header-cell *matHeaderCellDef>
            <mat-label>Modified</mat-label>
          </th>
          <td mat-cell *matCellDef="let manager" class="py-3">
            <mat-icon inline class="w-5 px-1">access_time</mat-icon>
            <span>{{ manager.lastUpdatedOn | formatdate }}</span>
            <br />
            <span>
              <p class="w-9/12 overflow-hidden truncate">
                <i class="icon icon-user"></i>
                {{ manager.lastUpdatedBy }}
              </p>
            </span>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="DISPLAYED_COLUMNS"
          class="px-4 py-3 border-t bg-project-600 border-t-project-700"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: DISPLAYED_COLUMNS"></tr>
      </table>

      <app-processing-boundary
        *ngIf="isProcessing"
        class="flex h-full"
        [isProcessing]="isProcessing"
        [processingMsg]="'Loading manager profiles...'"
        [cssClasses]="[
          'absolute',
          'top-[4.3rem]',
          'w-full',
          'h-full',
          'backdrop-contrast-50'
        ]"
      >
      </app-processing-boundary>

      <div
        class="flex items-center justify-between px-4 py-3 border-t bg-project-600 border-t-project-700"
        *ngIf="dataSource?.filteredData.length"
      >
        <div>
          <button
            class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100"
            (click)="loadContentData()"
            title="Refresh"
          >
            <i class="icon icon-refresh"></i>
          </button>
          <span class="pl-3">{{ pageSize }} per page</span>
        </div>
        <div>
          <button
            class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
            [disabled]="!hasPreviousPage()"
            (click)="loadPreviousPage()"
          >
            Previous
          </button>
          <button
            *ngFor="let num of pageNumbers"
            class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-white"
            (click)="selectPage(num)"
            [disabled]="isActivePage(num)"
            [ngClass]="{
              'content__page-button--current': isActivePage(num)
            }"
          >
            {{ num }}
          </button>
          <button
            class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
            (click)="loadNextPage()"
            [disabled]="!hasNextPage()"
          >
            Next
          </button>
        </div>
      </div>
    </div>
    <mat-paginator
      #paginator
      [pageIndex]="pageTracker"
      [pageSize]="pageSize"
      [pageSizeOptions]="pagingOptions"
      class="invisible"
    ></mat-paginator>
  </div>
</div>
